export default function request(app, done) {
  const request = app.request = {};

  // const setAuthHeader = (xhr) => xhr.setRequestHeader('Authorization', 'Basic ' + app.session.auth);

  request.custom = (method, module, endpoint, data) => {
    const customObj = { method: method, url: '/endpoint/' + module + '/' + endpoint };
    if (data) {
      customObj[method == 'GET' ? 'params' : 'body'] = data;
    }
    return m.request(customObj);
  };
}
